<template>
  <div class="lottery-details-container">
    <adminTable :tableLoading="tableLoading" :totalList="totalList" v-model:page="page" v-model:limit="limit"
      v-model:searchForm="searchForm" :tableData="tableData" @search="getList">
      <template v-slot:form-inline-items>
        <el-form-item>
          <el-input v-model="searchForm.period" placeholder="期号" clearable />
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.type" placeholder="彩票类型" clearable>
            <el-option label="澳彩" value="0" />
            <el-option label="港彩" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="searchForm.draw_date" type="date" placeholder="开奖日期" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.username" placeholder="用户名" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.phone" placeholder="手机号码" clearable />
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.is_test" placeholder="账号类型" clearable>
            <el-option v-for="item in accountTypeEnums" :label="item.label" :value="item.value" :key="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-col :span="11">
            <el-date-picker v-model="searchForm.starttime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="开始时间" style="width: 100%" />
          </el-col>
          <el-col :span="2" class="text-center">
            <span class="text-gray-500">-</span>
          </el-col>
          <el-col :span="11">
            <el-date-picker v-model="searchForm.endtime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="结束时间" style="width: 100%" />
          </el-col>
        </el-form-item>
      </template>
      <template v-slot:table>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column label="彩票类型" width="80">
          <template #default="scope">
            <el-tag :type="scope.row.type == 0 ? 'primary' : 'success'" size="small">
              {{ scope.row.type == 0 ? '澳彩' : '港彩' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="period" label="期号" width="120" />
        <el-table-column label="开奖号码" width="400">
          <template #default="scope">
            <div class="lottery-result">
              <div class="balls-container">
                <div v-for="i in 6" :key="i" class="ball-item">
                  <div :class="`ball ball-${scope.row[`color_${i}`]}`">
                    {{ scope.row[`ball_${i}`] }}
                  </div>
                  <div class="ball-info">
                    {{ scope.row[`zodiac_${i}`] }}/{{ scope.row[`element_${i}`] }}
                  </div>
                </div>
                <div class="plus">+</div>
                <div class="ball-item special">
                  <div :class="`ball ball-${scope.row.color_7}`">
                    {{ scope.row.ball_7 }}
                  </div>
                  <div class="ball-info">
                    {{ scope.row.zodiac_7 }}/{{ scope.row.element_7 }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="draw_datetime" label="开奖时间" width="160" />
        <el-table-column prop="status" label="状态" width="80">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '有效' : '无效' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" icon="Edit" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" icon="Delete" @click="deleteRecord(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </adminTable>

    <!-- Edit Dialog -->
    <el-dialog v-model="editDialogVisible" title="编辑开奖记录" width="600px">
      <el-form :model="editForm" label-width="80px">
        <el-form-item label="期号">
          <el-input v-model="editForm.period" disabled />
        </el-form-item>
        <el-form-item label="开奖号码">
          <div class="edit-balls">
            <div v-for="i in 6" :key="i" class="ball-input-group">
              <label>球{{ i }}</label>
              <el-input-number v-model="editForm[`ball_${i}`]" :min="1" :max="49" size="small" />
            </div>
            <div class="ball-input-group special">
              <label>特别号</label>
              <el-input-number v-model="editForm.ball_7" :min="1" :max="49" size="small" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.status">
            <el-option label="有效" :value="1" />
            <el-option label="无效" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="submitLoading">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from "element-plus";
import { accountTypeEnums } from "../../config/enums";

const route = useRoute()
const { proxy } = getCurrentInstance();

const searchForm = ref({
  period: "",
  type: "",
  draw_date: "",
  phone: "",
  username: "",
  is_test: "",
  starttime: "",
  endtime: "",
});

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);

// Edit dialog
const editDialogVisible = ref(false);
const submitLoading = ref(false);
const editForm = ref({
  id: null,
  period: "",
  ball_1: 1,
  ball_2: 2,
  ball_3: 3,
  ball_4: 4,
  ball_5: 5,
  ball_6: 6,
  ball_7: 7,
  status: 1
});

onMounted(() => {
  if (route.query && route.query.phone) {
    searchForm.value.phone = route.query.phone
  }
  getList();
});

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/LotteryDraw/getLotteryDrawLists",
    params: {
      page: page.value,
      limit: limit.value,
      ...searchForm.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

// Open edit dialog
const openEditDialog = (row) => {
  editForm.value = {
    id: row.id,
    period: row.period,
    ball_1: row.ball_1,
    ball_2: row.ball_2,
    ball_3: row.ball_3,
    ball_4: row.ball_4,
    ball_5: row.ball_5,
    ball_6: row.ball_6,
    ball_7: row.ball_7,
    status: row.status
  };
  editDialogVisible.value = true;
};

// Submit edit
const submitEdit = async () => {
  submitLoading.value = true;
  try {
    const res = await proxy.$http({
      method: "post",
      url: "/LotteryDraw/updateLotteryDraw",
      data: {
        id: editForm.value.id,
        ball_1: editForm.value.ball_1,
        ball_2: editForm.value.ball_2,
        ball_3: editForm.value.ball_3,
        ball_4: editForm.value.ball_4,
        ball_5: editForm.value.ball_5,
        ball_6: editForm.value.ball_6,
        ball_7: editForm.value.ball_7,
        status: editForm.value.status
      }
    });
    if (res.code == 0) {
      ElMessage.success("更新成功");
      editDialogVisible.value = false;
      getList();
    } else {
      ElMessage.error(res.msg || "更新失败");
    }
  } catch (error) {
    ElMessage.error("更新失败");
  } finally {
    submitLoading.value = false;
  }
};

// Delete record
const deleteRecord = (row) => {
  ElMessageBox.confirm(`确定要删除第 ${row.period} 期开奖记录吗?`, "警告", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  }).then(async () => {
    const res = await proxy.$http({
      method: "get",
      url: `/LotteryDraw/deleteLotteryDraw?id=${row.id}`,
    });
    if (res.code == 0) {
      ElMessage.success("删除成功");
      getList();
    } else {
      ElMessage.error(res.msg || "删除失败");
    }
  }).catch(() => {
    ElMessage.info("已取消删除");
  });
};
</script>

<style lang="less" scoped>
.lottery-result {
  .balls-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    .ball-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;

      .ball {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 14px;

        &.ball-red {
          background-color: #ff4757;
        }

        &.ball-blue {
          background-color: #3742fa;
        }

        &.ball-green {
          background-color: #2ed573;
        }
      }

      .ball-info {
        font-size: 11px;
        color: #666;
        text-align: center;
        white-space: nowrap;
      }

      &.special .ball {
        border: 2px solid #ffd700;
      }
    }

    .plus {
      font-size: 18px;
      font-weight: bold;
      color: #666;
      margin: 0 5px;
    }
  }
}

.edit-balls {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .ball-input-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    label {
      font-size: 12px;
      color: #666;
    }

    &.special label {
      color: #e6a23c;
      font-weight: bold;
    }
  }
}
</style>
